var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-100",attrs:{"id":"user-info-detail-page"}},[_c('UserInfoDetailComp')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }